import { FilterBase } from './FilterBase';


export class FilterGlider extends FilterBase {
        
    public ownerIds:Array<number>
    
    constructor({ownerIds = [] as Array<number>,...args} = {}) { 
        super(args)       
        this.ownerIds = ownerIds
    }
}
